import Table from "../../../../components/coreUiTable/Table"
import {connect} from "react-redux";
import { dataForStudioInfoTables } from "../utils/dataForTables";

export default connect(state => {
  const {tableInfo} = state.studioInfo.membershipActivityRevenue;
  return {
    table: tableInfo,
    ...dataForStudioInfoTables,
  };
})(Table);
